/* eslint-disable max-len */

/**
 * @author: Matthew Rawson @ 04/09/2017 14:47
 * @description: Custom TopUpCard Icon created as a React element in a similar manner to react-icons.
 * @notes: Could be moved to icon font file when that is implemented
 */
import React from "react"
import BaseSvgIcon from "./Base"

const TopUpCard = (props) => {
  return (
    <BaseSvgIcon {...props}>
      <path
        style={{fill: "#FFFFFF"}}
        d="M15 14v3c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1V9c0-.6.4-1 1-1h2V5c0-.6.4-1 1-1h11c.6 0 1 .4 1 1v8c0 .6-.4 1-1 1h-2zm-1 0H6c-.6 0-1-.4-1-1V9H3v8h11v-3zm-8-1V5h11v8H6zm1-6v2h9V7H7z"
      />
      <path d="M17 4H6c-.6 0-1 .4-1 1v3H3c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h11c.6 0 1-.4 1-1v-3h2c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1zm-3 13H3V9h2v4c0 .6.4 1 1 1h8v3zm3-4H6V5h11v8z" />
      <path d="M7 7h9v2H7z" />
    </BaseSvgIcon>
  )
}

export default TopUpCard
